"use client";

import Link from "next/link";
import { useState } from "react";
import { X } from "lucide-react";
import Image from "next/image";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <nav className="flex items-center justify-between bg-black/40 backdrop-blur h-16 px-4 mx-auto sm:px-6 lg:px-8 shadow-md">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-3">
          <div className="inline-flex items-center justify-center w-10 h-10 rounded-md bg-white backdrop-blur border border-white/20">
            <Image
              src="/logo.png"
              alt="logo"
              width={36}
              height={36}
              className="rounded"
            />
          </div>
          <span className="text-sm font-bold text-white tracking-wide">
            Embrace Rentals
          </span>
        </Link>

        {/* Desktop Nav Links */}
        <div className="items-center hidden gap-1 text-sm md:flex">
          {[
            { href: "/", label: "Home" },
            { href: "/vehicles", label: "Vehicles" },
            { href: "/about", label: "About" },
            { href: "/contact", label: "Contact" },
          ].map(({ href, label }) => (
            <Link
              key={href}
              href={href}
              className="text-white/80 hover:text-white hover:bg-blue-800 font-semibold rounded-md px-3 py-1.5 transition-colors"
            >
              {label}
            </Link>
          ))}
        </div>

        {/* CTA + Mobile Toggle */}
        <div className="flex items-center gap-3">
          <Link href="/vehicles">
            <div className="hidden md:flex px-4 py-2 text-sm font-bold rounded-md bg-white text-blue-900 hover:bg-blue-50 transition-colors shadow-sm">
              Explore Our Vehicles
            </div>
          </Link>

          {/* Custom Staggered Hamburger Menu Icon */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 flex flex-col justify-center items-end gap-1.5 w-10 h-10"
            aria-label="Toggle menu"
          >
            <span
              className={`block h-1 bg-white rounded-full transition-all duration-300 ${
                isOpen ? "w-8 rotate-45 translate-y-2" : "w-8"
              }`}
            ></span>

            <span
              className={`block h-1 bg-white rounded-full transition-all duration-300 ${
                isOpen ? "opacity-0" : "w-6"
              }`}
            ></span>

            <span
              className={`block h-1 bg-white rounded-full transition-all duration-300 ${
                isOpen ? "w-8 -rotate-45 -translate-y-2" : "w-3"
              }`}
            ></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isOpen && (
        <>
          {/* Soft overlay (very light) */}
          <div
            className="fixed inset-0 z-40 bg-black/20"
            onClick={() => setIsOpen(false)}
          />

          <aside
            className={`md:hidden fixed top-16 left-0 right-0 z-50 
      flex justify-center px-4
      transition-all duration-300 ease-in-out
      ${isOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4 pointer-events-none"}
    `}
          >
            {/* Centered Card */}
            <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl py-6 px-6 text-center">
              {/* Nav Links */}
              <nav className="flex flex-col gap-4 mb-6">
                {[
                  { href: "/", label: "Home" },
                  { href: "/vehicles", label: "Vehicles" },
                  { href: "/about", label: "About Us" },
                  { href: "/contact", label: "Contact" },
                ].map(({ href, label }) => (
                  <Link
                    key={href}
                    href={href}
                    onClick={() => setIsOpen(false)}
                    className="text-gray-700 text-base font-medium hover:text-cyan-600 transition"
                  >
                    {label}
                  </Link>
                ))}
              </nav>

              {/* Buttons */}
              <div className="flex flex-col gap-3">
                <Link href="/vehicles" onClick={() => setIsOpen(false)}>
                  <button className="w-full   rounded-lg text-gray-700 font-medium  transition">
                    Book Now
                  </button>
                </Link>

                <Link href="/about" onClick={() => setIsOpen(false)}>
                  <button className="w-full py-2 rounded-lg  text-gray-700 font-medium  transition">
                    Portfolio
                  </button>
                </Link>
              </div>
            </div>
          </aside>
        </>
      )}
    </header>
  );
}
